const FieldError = ({ id, message }: { id: string; message?: string }) =>
  message ? (
    <p id={id} className="text-sm text-red-400">
      {message}
    </p>
  ) : null;

export default FieldError;
